import styled from 'styled-components';
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

const EditFieldModalWrapper = styled(Modal)`
  .preview-form-area {
    border: solid 1px gray;
    padding: 20px;
  }
  .btn-success{
      background-color: #0B2A1B!important;
      border-color: #0B2A1B!important;
  }
`;

export default WithDirection(EditFieldModalWrapper);